import { get, post, put } from '@/services/http'
import { getUserToken } from '@/services/authService'
import { isEmpty } from '@/utils/StringUtil'

export function createContact(data) {
  return post(`/api/v1/contacts`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}

export function editContact(data) {
  return put(`/api/v1/contacts/edit`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}

export function fetchContact() {
  return get(`/api/v1/contacts/fetch`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}

export function fetchContactsByCriteria(keyword, size, page, sort) {
  return get(`/api/v1/contacts/fetch/criteria?size=${size}&page=${page}&sort=${sort}${!isEmpty(keyword) ? `&keyword=${keyword}` : ""}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}

export function fetchProfile(username) {
  return get(`/api/v1/contacts/profile?username=${username}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}

export function requestAccount(data) {
  return put(`/api/v1/contacts/request-account/request`, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function setRequestAccountDesicion(body) {
  return put(`/api/v1/contacts/request-account/decision`, body, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}

export function fetchRequestAccountById(id) {
  return get(`/api/v1/contacts/fetch/request-account?id=${id}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}

export function updateContactLockState(username, locked) {
  return put(`/api/v1/contacts/update/lock-state?username=${username}&locked=${locked}`, {empty: true}, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
